import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import "./Users.scss";
import httpApiCall from "../../service/api.service";
import { getStorageValue } from "../../service/shared.service";
import { formatDate, formatDate2 } from "../../utils/DateFormat";
import Table from "../elements/tableComponent";
import toastr from "../elements/toast";
import { dataLoading } from "../../assets/assets";

const Users = () => {
  const toastrService = new toastr(true);
  const [shimmer, setShimmer] = useState(false);

  const columns = [
    { title: "S.NO", dataKey: "sno" },
    { title: "Registration Date", dataKey: "rd" },
    { title: "Name", dataKey: "name" },
    { title: "Email", dataKey: "email" },
    { title: "Action", dataKey: "action" },
  ];
  const [data, setData] = useState({ name: "", email: "" });
  const [show, setShow] = useState(false);
  const [id, setId] = useState();
  const [confirm, setConfirm] = useState(false);
  const [userList, setUserList] = useState<any>();
  const Profile = getStorageValue("partnerProfile");
  const profileData = Profile && Profile.length ? Profile[0] : {};
  const currentDate = new Date();
  const [startOfMonth, setStartOfMonth] = useState(
    new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
  );
  const [sppiner, setSppiner] = useState(false);


  useEffect(() => {
    getUserList();
  }, []);

  const getUserList = async () => {
    setShimmer(true);
    const body = {
      access_token: profileData.access_token,
      limit: 10,
      filter: "",
      search_string: "",
      para_id: profileData.para_id,
      partner_json: profileData.partner_json,
      offset: 0,
      added_by: 1,
      referral_code: profileData.referral_code,
      sort_order: "",
      time_offset: "",
      sort_by: "",
      current_agent_id: "",
      language_preffered: profileData.language_preffered,
      start_date: formatDate(startOfMonth),
      end_date: formatDate(currentDate),
    };

    await httpApiCall({ api: "list_partner_user", type: "POST", body })
      .then((data) => {
        setShimmer(false);
        if (data && !data.is_error) {
          setUserList(data);
        }
      })
      .catch((error) => {
        console.error("There was a problem with the Users params:", error);
      });
  };

  const rows =
    userList &&
    userList["list"].map((row: any, index: number) => [
      index + 1,
      formatDate2(row.created),
      row.user_name,
      row.user_email,
      <button className="cursor p-2"  onClick={() => {setConfirm(true); setId(row.pu_id);}}>Delete</button>    ]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter valid name"),
    email: Yup.string()
      .email("Invalid email address").trim()
      .required("Please enter valid Email address"),
  });
  const handleDelete = async (id:any) =>{
    setSppiner(true);
    // console.log(id);
    const body = {
      access_token: profileData.access_token,
      pu_id: id.toString(),

    }
    await httpApiCall({ api: "delete_partner_user", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data && !data.is_error) {
          getUserList();
          setConfirm(false)
          toastrService.showSuccess("User Deleted successfully");
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.error("There was a problem with the Users params:", error);
      });
    

  }

  const handleSubmit = async (values: any) => {
    setSppiner(true);
    const body = {
      access_token: profileData.access_token,
      email: values.email.trim(),
      name: values.name.trim(),
      referral_code: profileData.referral_code,
    };

    await httpApiCall({ api: "add_partner_user", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data && !data.is_error) {
          setShow(false);
          getUserList();
          toastrService.showSuccess("User added successfully");
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.error("There was a problem with the Users params:", error);
      });
  };

  return (
    <div>
    
      <div className="user">
        <div className="d-flex align-items-center justify-content-end pe-4">
        <div className="user-header text-end p-4">
          <Button onClick={() => setShow(true)}>Add Users</Button>
        </div>
        { userList && userList.list?.length > 0 && (
          <div>
          <Button>Total Users : {userList?.list?.length}</Button>
          </div>
        )}
       
        </div>
       
        {shimmer && (
          <div className="no_data_v2 text-center">
            <img src={dataLoading} alt="" />
          </div>
        )}
        <div className="user-body p-4">
         { !shimmer &&  <Table callFunction={() => console.log('call from users')} data={rows} columns={columns}></Table>}
        </div>
        <Modal show={show} onHide={() => setShow(false)} animation={false} backdrop="static" centered>
          <Modal.Header closeButton className="popup-header">
            Add User
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={data}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
            >
              <Form>
                <div className="form-group">
                  <label htmlFor="">
                    Name <span className="text-danger">*</span>
                  </label>
                  <Field
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    name="name"
                  />
                  <ErrorMessage
                    name="name"
                    component="small"
                    className="text-danger m-2"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="">
                    Email <span className="text-danger">*</span>
                  </label>
                  <Field
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                  />
                  <ErrorMessage
                    name="email"
                    component="small"
                    className="text-danger m-2"
                  />
                </div>
                <Modal.Footer className="d-flex justify-content-between p-0">
                  <Button onClick={() => setShow(false)}>Close</Button>
                  <Button disabled={sppiner} type="submit">
                    Add
                    {sppiner && (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                  </Button>
                </Modal.Footer>
              </Form>
            </Formik>
          </Modal.Body>
        </Modal>
      </div>

      <Modal show={confirm} onHide={() => setConfirm(false)} animation={false} centered className="logout">
        <Modal.Header className="justify-content-center">
        <h4>Delete Confirmation</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p className="mb-0">Are you sure you want to Delete?</p>
          </div>
        </Modal.Body>
        <Modal.Footer className=" d-flex justify-content-center mb-2">
          <Button variant="primary"  onClick={() => setConfirm(false)} >
            Cancel
          </Button>
          <Button disabled={sppiner} variant="secondary" onClick={() => handleDelete(id)} >
            Confirm
            {sppiner && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="ms-2"
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Users;
